import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../../config/api.config';
import { LicensesResponseModel } from '../../models/ecommerce/license.model';

@Injectable({
    providedIn: 'root',
})
export class LicensesRepositoryService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = apiEndpoints.licenses;

    public listLicenses(limit: number, offset: number): Observable<LicensesResponseModel> {
        const params = new HttpParams().set('limit', limit).set('offset', offset);
        return this.http.get<LicensesResponseModel>(this.baseUrl, { params });
    }
}
